<template>
  <button
    class="magic-ui-button"
    @click="clickHandler"
    @keydown.enter="clickHandler"
  >
    <slot>
      <magic-ui-text
        :style="textStyle"
        :config="textConfig"
        :disabled="hoc.disabled"
      />
    </slot>
  </button>
</template>

<script>
export default {
  name: 'MagicUiButton',

  inject: {
    hoc: {
      default: {},
    },
  },

  props: {
    config: {
      type: Object,
      default: () => {},
    },

    model: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      handler: {},
      textConfig: {
        text: this.config.text,
        disabledText: this.config.disabledText,
        html: this.config.html,
      },
      textStyle: {
        fontSize: this.hoc?.style?.fontSize,
      },
    };
  },

  computed: {
    beforeLgoinHandleKey() {
      return `magic_ui_button_${this.config.id}`;
    },
  },

  watch: {
    config: {
      deep: true,
      handler(config) {
        this.textConfig.text = config.text;
        this.textConfig.disabledText = config.disabledText;
        this.textConfig.html = config.html;
      },
    },
  },

  async mounted() {
    if (this.config.act?.toLowerCase().endsWith('pop')) {
      this.pushHandler(async () => this.app.openPop(this.config.pop, this.config));
    }

    // 执行登录前的动作
    if (!this.inHippy) {
      const beforeLgoinHandleTime = +window.localStorage.getItem(this.beforeLgoinHandleKey);
      if (beforeLgoinHandleTime) {
        window.localStorage.removeItem(this.beforeLgoinHandleKey);
        const now = new Date().getTime();
        // 登录之前30秒内的操作还有效
        if (now - 30000 <= beforeLgoinHandleTime) {
          setTimeout(() => this.clickHandler(), 0);
        }
      }
    }
  },

  methods: {
    setDisabled(v) {
      this.hoc.disabled = v;
    },

    pushHandler(eventHandler, needLogin) {
      const { handler } = this;
      let actions = [];

      if (typeof handler === 'function') {
        actions.push(handler);
      } else if (handler.actions) {
        ({ actions } = handler);
      }

      actions.push(eventHandler);

      this.$set(this.handler, 'actions', actions);
      this.$set(this.handler, 'needLogin', needLogin || false);
    },

    loginHandler(handler) {
      const url = handler.url || this.config?.handler?.url;
      if (this.config.afterLoginAction) {
        // 缓存时间，30秒内登录完可以继续执行本次操作
        window.localStorage.setItem(this.beforeLgoinHandleKey, `${new Date().getTime()}`);
      }

      this.openLogin(url);
    },

    async clickHandler() {
      const handler = this.handler || {};
      const actions = [].concat(this.config?.handler?.actions || [], handler.actions || []);
      const needLogin = handler.needLogin || this.config?.handler?.needLogin;

      if (needLogin === true) {
        await this.loginReady;
        if (!this.isLogin) {
          this.loginHandler(handler);
          return false;
        }
      }

      if (this.inHippy) {
        this.$bus.$emit('magic:common:events:click', this);
      }

      if (!actions.length) {
        return false;
      }

      try {
        for (let i = 0; i < actions.length; i++) {
          const fuc = actions[i].fuc || actions[i];
          if (typeof fuc !== 'function') {
            continue;
          }
          const result = await fuc(this, { model: this.model });
          if (result === false) {
            break;
          }
        }
      } catch (e) {
        // this.toast('操作失败');
        // eslint-disable-next-line no-console
        console.error(e);
      }

      return true;
    },
  },
};
</script>
